import { styled, keyframes as keyframes2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { keyframes } from 'styled-components';
import { token } from '@atlaskit/tokens';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils/src/utils/component-with-condition/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { Skeleton as SkeletonCompiledNew } from './Skeleton.tsx';
import { Spacer as SpacerCompiledNew } from './Spacer.tsx';

/**
 * @deprecated styled version is deprecated, please use the compiled version
 */
export const getKeyframes = (offsetX = 0): string => {
	const fromPositionX = -Math.abs(offsetX) - 300;
	const toPositionX = fromPositionX + 2000;
	return keyframes({
		'0%': {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
			backgroundPosition: `${fromPositionX}px 0`,
		},
		'100%': {
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
			backgroundPosition: `${toPositionX}px 0`,
		},
	});
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const SkeletonCompiledOld = styled.div<{
	height?: string | number;
	width?: string | number;
}>({
	animationDelay: '0s',
	animationDuration: '1s',
	animationFillMode: 'forwards',
	animationIterationCount: 'infinite',
	animationName: keyframes2({
		'0%': {
			backgroundPosition: '-300px 0',
		},
		'100%': {
			backgroundPosition: '1700px 0',
		},
	}),
	animationTimingFunction: 'linear',
	backgroundColor: token('color.skeleton'),
	backgroundImage: `linear-gradient( to right, ${token('color.skeleton')} 10%, ${token('color.skeleton.subtle')} 30%, ${token('color.skeleton')} 50% )`,
	backgroundRepeat: 'no-repeat',
	borderRadius: token('radius.xsmall'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	height: (props) => props.height,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	width: (props) => props.width,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export const SkeletonCompiled = componentWithCondition(
	() => fg('pol-17944_update_skeleton_and_spacer_styles'),
	SkeletonCompiledNew,
	SkeletonCompiledOld,
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const SpacerCompiledOld = styled.div<{ height: string }>({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
	height: (props) => props.height,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export const SpacerCompiled = componentWithCondition(
	() => fg('pol-17944_update_skeleton_and_spacer_styles'),
	SpacerCompiledNew,
	SpacerCompiledOld,
);

export const Skeleton = SkeletonCompiled;

export const Spacer = SpacerCompiled;
